<template>
  <summary-section :heading="heading" data-test-id="profile-about-me-summary-section">
    <template v-slot:actions>
      <router-link
        v-if="link"
        :to="link"
        class="summary-section__action-link"
      >
        Edit
      </router-link>
    </template>
    <template class="about-me-summary">
      <loading-spinner v-if="loading !== 0" />
      <ul v-else class="about-me-summary__list list-reset">
        <li
          v-for="answer in publicProfile"
          :key="answer.id"
          class="about-me-summary__item"
        >
          <icon-component
            v-if="answer.profileField.icon"
            :name="answer.profileField.icon"
            class="about-me-summary__icon"
            :class="`about-me-summary__icon--${answer.profileField.icon}`"
          />
          <span v-else class="about-me-summary__icon-placeholder" />
          {{ answer.value }}
        </li>
        <li class="about-me-summary__item">
          <icon-component name="clock" class="about-me-summary__icon" />
          Member Since {{ memberSince }}
        </li>
      </ul>
    </template>
  </summary-section>
</template>

<script>
import SummarySection from '@/components/User/Summary/SummarySection.vue';
import { PUBLIC_PROFILE_QUERY } from '@/graphql/queries/user-queries';
import { mapGetters } from 'vuex';

export default {
  components: {
    SummarySection,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: 0,
      publicProfile: [],
    };
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    memberSince() {
      return new Date(this.user.insertedAt).getFullYear();
    },
    heading() {
      return this.user.id === this.currentUser.id ? 'About Me' : `About ${this.user.username}`;
    },
  },
  apollo: {
    publicProfile: {
      query: PUBLIC_PROFILE_QUERY,
      variables() {
        return {
          userId: this.user.id,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_about-me-summary';
</style>
